import { getContext, setContext } from 'svelte';

export const NAVIGATION_STATE_CONTEXT_KEY = Symbol('navigation-state-context');

export interface NavigationStateContextOptions {
  globalQueryParams: Record<string, string>;
}

export interface NavigationStateContext {
  readonly globalQueryParams: Record<string, string>;
}

export const provideNavigationStateContext = (
  getOptions: () => NavigationStateContextOptions
) => {
  return setContext(NAVIGATION_STATE_CONTEXT_KEY, {
    get globalQueryParams() {
      return getOptions().globalQueryParams;
    },
  });
};

export const useNavigationState = (): NavigationStateContext => {
  const context = getContext<NavigationStateContext>(
    NAVIGATION_STATE_CONTEXT_KEY
  );
  if (!context) {
    throw new Error('Navigation state context not found');
  }
  return context;
};
